import { GeoUtils } from '@front/volcanion/utils'
import FormatUtils from '@front/squirtle/utils/format'

import _ from "lodash"

const verifyData = (isValid, value, nullValue = undefined) => !!isValid ? value : nullValue

const getLoadsInfo = (values, state, { CODE_INTERNATIONAL }) => ({
  src_contact: values?.loads?.src_contact,
  src_phone: verifyData(values?.loads?.src_phone, FormatUtils.parsePhoneNumber(values?.loads?.src_phone, CODE_INTERNATIONAL)),
  dest_contact: values?.loads?.dest_contact,
  dest_phone: verifyData(values?.loads?.dest_phone, FormatUtils.parsePhoneNumber(values?.loads?.dest_phone, CODE_INTERNATIONAL), undefined)
})

const getOrderInfo = (values, state, extra) => ({
  margin: state?.margin,
  src_comment: values?.info?.src_comment,
  dest_comment: values?.info?.dest_comment,
  call_id: state?.call_id,
  meeting_point: state?.info?.meeting_point?.translated,
  meeting_point_trkey: state?.meeting_point?.trkey,
  driver_instruction: state?.info?.driver_instruction?.translated,
  driver_instruction_trkey: state?.driver_instruction?.trkey,
  duration: values?.ridemode_duration
})

const getBillingData = (values, state, extra) => {
  const {
    base,
    fees,
    prepaid,
    handling,
    load_type,
    load_count,
    assigned_transport,
    quotation,
    duration_amount,
    option_amount
  } = values

  const { hasJobPayment, billing } = state

  if (!billing) return {}

  return {
    assigned_transport: {
      passenger_count: verifyData(load_type === 'user', load_count),
      package_count: verifyData(load_type === 'package', load_count),
      info: {
        effective_handling_duration: verifyData(assigned_transport?.info?.effective_handling_duration, assigned_transport?.info?.effective_handling_duration),
        billed_handling_duration: verifyData(assigned_transport?.info?.billed_handling_duration, assigned_transport?.info?.billed_handling_duration),
      },
      payment: {
        handling,
        base: verifyData(quotation?.base && hasJobPayment, quotation.base),
        fees: verifyData(quotation?.fees && hasJobPayment, quotation.fees),
        prepaid: verifyData(quotation?.prepaid && hasJobPayment, quotation.prepaid),
        duration_amount: verifyData(duration_amount && hasJobPayment, duration_amount),
        option_amount: verifyData(option_amount && hasJobPayment, option_amount)
      }
    },
    job: {
      payment: {
        handling,
        base: verifyData(base && hasJobPayment, base),
        fees: verifyData(fees && hasJobPayment, fees),
        prepaid: verifyData(prepaid && hasJobPayment, prepaid),
        duration_amount: verifyData(duration_amount && hasJobPayment, duration_amount),
        option_amount: verifyData(option_amount && hasJobPayment, option_amount)
      }
    }
  }
}

const getAddressInfo = (values, state, extra) => {
  const { prefix, save_comment } = extra
  const prefix_field = prefix === 'source' ? 'src' : 'dest'
  const comment = _.get(values, `info.${prefix_field}_comment`)

  if (prefix === 'destination' && !!_.has(values, prefix) && !_.get(values, prefix))
    return null

  if (!!_.get(values, prefix))
    return _.merge(
      {},
      _.pick(_.get(values, prefix), _.flatten([GeoUtils.getAddressKeys(), ['name', 'owner']])),
      { comment: !!save_comment ? comment : null },
    )

  return undefined
}

const getReservationInfo = (values, state, extra) => {
  const { source_reservationinfo_id, order_reservationinfo_id } = state
  const { reservationinfo } = values

  if (!_.isEmpty(reservationinfo)) {
    return !!source_reservationinfo_id
      ? [_.merge({ reservationinfo: source_reservationinfo_id, order_reservationinfo_id }, reservationinfo)]
      : []
  } else if (!source_reservationinfo_id) {
    return []
  }
  else
    return undefined
}

const getUser = (values, state, extra) => {
  const { isB2B, selected_user, user_id } = state
  const { user } = values
  if (!!isB2B)
    return selected_user
  else if (!!user_id)
    return user_id
  else {
    return {
      auth: {
        gsm: user?.gsm,
        application: user?.application,
        user_type: 'booker'
      },
      customerinfo: {
        name: user?.name,
        client_number: user?.client_number,
      },
      info: {
        preferred_language: 'fr',
        first_name: user?.first_name,
        last_name: user?.last_name
      }
    }
  }
}

const getBillingSectionFromRecord = (record) => {
  const jobPayment = record?.job?.payment || {}
  const transportPayment = record?.assigned_transport?.payment || {}

  return {
    assigned_transport: {
      info: {
        effective_handling_duration: record?.assigned_transport?.info?.effective_handling_duration || '0',
        billed_handling_duration: record?.assigned_transport?.info?.billed_handling_duration || '0'
      }
    },
    handling: jobPayment.handling || transportPayment.handling || '0',
    base: jobPayment.base || transportPayment.base || '0',
    driver_package_fee: jobPayment.driver_package_fee || transportPayment.driver_package_fee || '0',
    fees: jobPayment.fees || transportPayment.fees || '0',
    prepaid: jobPayment.prepaid || transportPayment.prepaid || '0',
    payment_ref: record?.payment_ref,
    billing_status: record?.billing_status || undefined,
    billing_customer_comment: record?.billing_customer_comment,
    billing_member_comment: record?.billing_member_comment,
    duration_amount: transportPayment.duration_amount || jobPayment.duration_amount || '0',
    option_amount: transportPayment.option_amount || jobPayment.option_amount || '0',
    service_amount: transportPayment.service_amount || '0',
    discount: transportPayment.discount || '0'
  }
}

export {
  getLoadsInfo,
  getOrderInfo,
  getBillingData,
  getAddressInfo,
  getReservationInfo,
  getUser,
  verifyData,
  getBillingSectionFromRecord
}
